import { render, staticRenderFns } from "./CompModal.vue?vue&type=template&id=327702d3&scoped=true"
import script from "./CompModal.vue?vue&type=script&lang=js"
export * from "./CompModal.vue?vue&type=script&lang=js"
import style0 from "./CompModal.vue?vue&type=style&index=0&id=327702d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327702d3",
  null
  
)

export default component.exports